export default __webpack_public_path__ + "locales/sk/Common.json?hash=043d7ed5e7a99bcbacb690919ac520ba";